import axios from 'axios';
import urlList from '@utils/urlList';
import { getMockBossStoreSelected, getMockOrder } from './mockUtils';

/* ITEMS */
export const deleteOrderItem = async (hostname: string, data: object) => {
    return new Promise((resolve, reject) => {
      const url = hostname + urlList['DELETE_ORDER_ITEM'] + '?nocache=' + new Date().getTime();
  
        if(url) {
          axios({
            url,
            method: 'PUT',
            data: data,
            withCredentials: true
          })
          .then((res: any) => {
            resolve(res.data);
          })
          .catch((err: any) => {
            reject(err.response);
          })
        }
      });
  }

export const getPrescription = async (hostname: string, orderItemId: string) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['GET_PRESCRIPTION'] + '/' + orderItemId + '?nocache=' + new Date().getTime();

      if(url) {
        axios({
          url,
          method: 'GET',
          withCredentials: true,
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
    });
}

export const sendPrescription = async (hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['SEND_PRESCRIPTION'] + '?nocache=' + new Date().getTime();

    if(url) {
      axios({
        url,
        method: 'PUT',
        data: data,
        withCredentials: true
      })
      .then((res: any) => {
        resolve(res);
      })
      .catch((err: any) => {
        reject(err.response);
      })
    }
  });
}

/* ADD TO CART */
export const addToCart = async (hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['ADD_TO_CART'];

    if(url) {
      axios({
        url,
        method: 'POST',
        data: data,
        timeout: 10000,
      })
      .then((response: any) => {
        if(response.errorCode === undefined) {
          resolve(response.data);
        } else {
          console.error(response.errorCode);
        }
      })
      .catch((err: any) => {
        reject(err);
      })
    }
  });
}

/* CALCULATE INSURANCE BENEFIT */
export const calculateProductInsuranceBenefit = async (hostname: string, catalogId: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['CALCULATE_INSURANCE_BENEFIT'].replace('##CATALOGID##', catalogId);

    if(url) {
      axios({
        url,
        method: 'POST',
        data: data,
        timeout: 40000,
      })
      .then((response: any) => {
        resolve(JSON.parse(response.data.__PAIR_DISCOUNT));
      })
      .catch((err: any) => {
        reject(err);
      })
    }
  });
}
  
/* SHIPPING INFO */
export const updateShippingInfo = async (hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['UPDATE_SHIPPING_INFO'] + '?nocache=' + new Date().getTime();
  
      if(url) {
        axios({
          url,
          method: 'PUT',
          data: data,
          withCredentials: true
        })
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
}

/* PROMO CODE */
export const postPromoCode = async (hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['POST_PROMO_CODES'] + '?nocache=' + new Date().getTime();

    if(url) {
      axios({
        url,
        method: 'POST',
        data: data,
        withCredentials: true
      })
      .then((res: any) => {
        if(res.status === 201) {
          resolve(true);
        }
      })
      .catch((err: any) => {
        reject(err);
      })
    }
  });
}

export const deletePromoCode = async (hostname: string, code: string) => {
    return new Promise((resolve, reject) => {
        const url = hostname + urlList['DELETE_PROMO_CODES'] + '/' + code + '?nocache=' + new Date().getTime();
    
        if(url) {
          axios({
            url,
            method: 'DELETE',
            withCredentials: true
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err: any) => {
            reject(err.response);
          })
        }
      });
}

/* ITEM PROPERTIES */
export const getItemProperties = async (url: string) => {
    return new Promise((resolve, reject) => {          
        if(url) {
          url = url.replace('/wcs/', '/search/') + '?profileName=RONA_findProductByIds_Summary';
          axios({
            url,
            method: 'GET',
            withCredentials: true
          })
          .then((res: any) => {
            resolve(res.data);
          })
          .catch((err: any) => {
            reject(err.response);
          })
        }
    });
}

/* ADDRESS */
export const postAddress = async (hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['ADD_ADDRESS']  + '?nocache=' + new Date().getTime();
  
      if(url) {
        axios({
          url,
          method: 'PUT',
          data: data,
          withCredentials: true
        })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
}

/* POST ADDRESS BOSS */
export const postAddressBoss = async (hostname: string, storeId: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['ADD_ADDRESS_BOSS'].replace('##STOREID##', storeId)  + '?nocache=' + new Date().getTime();
  
      if(url) {
        axios({
          url,
          method: 'POST',
          data: data,
          withCredentials: true
        })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
}

export const validateAddress = async (hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['VALIDATE_ADDRESS']  + '?nocache=' + new Date().getTime();
    
    if(url) {
      axios({
        url,
        method: 'PUT',
        data: data,
        withCredentials: true
      })
      .then((res: any) => {
        resolve(res);
      })
      .catch((err: any) => {
        reject(err.response);
      })
    }
  })
}

/* PAYMENT */
export const addPayment = async(hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['ADD_PAYMENT']  + '?nocache=' + new Date().getTime();

      if(url) {
        axios({
          url,
          method: 'PUT',
          data: data,
          withCredentials: true
        })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
}

export const preparePayment = async(hostname: string, data = {}) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['PREPARE_PAYMENT']  + '?nocache=' + new Date().getTime();

      if(url) {
        axios({
          url,
          method: 'PUT',
          data: data,
          withCredentials: true
        })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
}

export const submitPayment = async(hostname: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['SUBMIT_PAYMENT']  + '?nocache=' + new Date().getTime();

    if(url) {
      axios({
        url,
        method: 'POST',
        data: data,
        withCredentials: true
      })
      .then((res: any) => {
        resolve(res);
      })
      .catch((err: any) => {
        reject(err.response);
      })
    }
  });
}

export const getOrder = async(mockRequests: boolean, hostname:string, orderId: string, email: string) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['GET_ORDER'] + '/' + orderId + '?email=' + email  + '&nocache=' + new Date().getTime();

      if(url) {
        return(mockRequests 
          ? getMockOrder() :
        axios({
          url,
          method: 'GET',
          withCredentials: true,
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        }))
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err);
        })
      }
    });
}

export const getCartForAddressId  = (mockRequests: boolean, hostname: string) => {
  return new Promise((resolve, reject) => {
      const url = hostname + urlList['GET_CART'] + '?nocache=' + new Date().getTime();
      
      if(url) {
        axios({
          url,
          method: 'GET',
          withCredentials: true,
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        })
        .then((res: any) => {
          resolve(res);
        })
        .catch((err: any) => {
          reject(err.response);
        })
      }
  });
};



/* BOSS */
export const fetchPhysicalStores = async (hostname: string, storeId: string, lat: string, lng: string, data: object, radius: string) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['URL_GET_STORE_BOSS'].replace('##STOREID##', storeId).replace('##LAT##', lat).replace('##LNG##', lng).replace('##RADIUS##', radius).replace('##PAGESIZE##', radius);

    if(url) {
        axios({
        url,
        method: 'POST',
        data: data
        })
        .then((res) => {
            resolve(res.data);
        })
        .catch((err) => {
            reject(err.response);
        })
    }
    });
}


/* ESPOT */

export const getEspot = (hostname: string, espotName: string) => {

  return new Promise((resolve, reject) => {
    const url = hostname + urlList['GET_ESPOT']  + espotName + '?nocache=' + new Date().getTime();
    if(url) {
      axios({
        url,
        method: 'GET',
        withCredentials: true
      }).then((response: any) => {
        let res = response?.data?.MarketingSpotData?.[0]?.baseMarketingSpotActivityData?.[0]?.marketingContentDescription?.[0]?.marketingText;
        resolve(res);
      })
      .catch((err: any) => {
        reject(err.response);
      })
    }
  })

}

/* POST BOSS DELIVER HERE */
export const setBossShipping = async (hostname: string, storeId: string, data: object) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['URL_SET_STORE_BOSS'].replace('##STOREID##', storeId);

    if(url) {
        axios({
        url,
        method: 'POST',
        data: data,
        headers: {
          'Content-Type': 'application/json'
        },
        })
        .then((res) => {
            resolve(res.data);
        })
        .catch((err) => {
            reject(err.response);
        })
    }
    });
}

export const getBossStoreSelected = async (mockRequests: boolean, hostname: string, storeId: string, identifier: string) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['URL_GET_STORE_BOSS_SELECTED'].replace('##STOREID##', storeId).replace('##IDENTIFIER##', identifier);

    if(url) {
        mockRequests ? 
         getMockBossStoreSelected()
         .then((res) => {
          resolve(res.data);
          })
          .catch((err) => {
              reject(err.response);
          })
        : axios({
        url,
        method: 'GET'
        })
        .then((res) => {
            resolve(res.data);
        })
        .catch((err) => {
            reject(err.response);
        })
    }
    });
}

export const getLensPackages = (hostname: string, frameId: string) => {
  return new Promise((resolve, reject) => {
    const url = hostname + urlList['GET_LENSES'].replace('##FRAMEID##', frameId);
    if(url) {
      axios({
        url,
        method: 'GET',
      }).then((response: any) => {
        resolve(response.data.response.data);
      })
      .catch((err: any) => {
        reject(err.response);
      })
    }
  })

}